import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const Histogram = ({ data }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        // Set up the chart dimensions and margins
        const margin = { top: 30, right: 20, bottom: 40, left: 30 };
        const viewboxHeight = 250;
        const viewboxWidth = 400;
        const svg = d3.select(chartRef.current)
            .attr("viewBox", `0 0 ${viewboxWidth} ${viewboxHeight}`)
            .attr("preserveAspectRatio", "xMidYMid meet");

        const innerWidth = viewboxWidth - margin.left - margin.right;
        const innerHeight = viewboxHeight - margin.top - margin.bottom;

        // Clear previous content
        svg.selectAll("*").remove();

        // Create main group
        const chart = svg
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        // Extract data
        const days = data.map(([day]) => day);
        const values = data.map(([, value]) => value);
        const maxY = Math.ceil(d3.max(values)) + 1;

        // Create scales
        const x = d3.scaleBand()
            .domain(days)
            .range([0, innerWidth])
            .padding(0.4); // Slimmer bars

        const y = d3.scaleLinear()
            .domain([0, maxY])
            .range([innerHeight, 0]);

        // Create axes
        const xAxis = d3.axisBottom(x).tickSize(0);

        const yAxis = d3.axisLeft(y).ticks(maxY).tickFormat(d3.format("d"));

        // Append x-axis
        chart.append("g")
            .attr("transform", `translate(0,${innerHeight + 5})`)
            .call(xAxis)
            .selectAll("text")
            .style("text-anchor", "middle")
            .style("fill", "white")
            .style("font-family", "Comic Sans MS, Comic Neue, Marker Felt, Chalkboard, sans-serif")
            .style("font-size", "14px")
            .style("font-weight", "500")
            .attr("dy", "1.25em");

        // Append y-axis
        chart.append("g")
            .call(yAxis)
            .selectAll("text")
            .style("fill", "white")
            .style("font-family", "Comic Sans MS, Comic Neue, Marker Felt, Chalkboard, sans-serif")
            .style("font-size", "14px")
            .style("font-weight", "550")
            .attr("dy", "1em");

        chart.append("text")
            .attr("x", 0)
            .attr("y", -15) // Position slightly above the top tick
            .attr("text-anchor", "middle")
            .style("fill", "white")
            .style("font-family", "Comic Sans MS, Comic Neue, Marker Felt, Chalkboard, sans-serif")
            .style("font-size", "16px")
            .style("font-weight", "bold")
            .text("Flows");

        // Draw bars with shadow effect
        chart.selectAll(".bar-shadow")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", "bar-shadow")
            .attr("x", ([day]) => x(day) + 4)
            .attr("y", ([, value]) => y(value) + 4)
            .attr("width", x.bandwidth())
            .attr("height", ([, value]) => innerHeight - y(value))
            .attr("fill", "#3d5a80");

        chart.selectAll(".bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", "bar")
            .attr("x", ([day]) => x(day))
            .attr("y", ([, value]) => y(value))
            .attr("width", x.bandwidth())
            .attr("height", ([, value]) => innerHeight - y(value))
            .attr("fill", "#ffffff")
            .attr("stroke", "black")
            .attr("stroke-width", 2);
    }, [data]);

    return (
        <div style={{ width: "100%", height: "auto", display: "flex", justifyContent: "center" }}>
            <svg ref={chartRef} width="100%" />
        </div>
    );
};

export default Histogram;